<template>
	<div class="view-container">
		<modal :showDialog="(activeModal == 'ADD_TICKET')" @close="closeModal" :title="$t('AddTicket')">
			<ticket-modal :system-id="systemId" @saved="closeModal"/>
		</modal>
		<div class="max-grid" style="flex-direction: row;">
			<ejs-grid ref="grid" height="100%" width="100%" :toolbar="toolbar" :toolbarClick="toolbarClick" :selectionSettings="selectionOptions" :allowTextWrap="false" :dataBound="dataBound" :dataSource="tickets" :allowPaging="true" :pageSettings="pageSettings" :allowFiltering="true" :filterSettings="filterOptions" :allowSorting="true" :allowMultiSorting='true' :allowPdfExport='true' :allowCsvExport='true' :allowExcelExport='true' :showBusyIndicator="true" :rowDataBound="rowDataBound" :rowSelected="selectionChanged" >
				<e-columns>
					<e-column field="createDate" :headerText="$t('CreateDate')" width="250" textAlign="Left" :customAttributes="customAttributes" type="dateTime" :format="dateTimeFormatOptions"></e-column>
					<e-column field="assigneeName" :headerText="$t('AssigneeName')" width="300" textAlign="Left" :customAttributes="customAttributes"></e-column>
					<e-column field="status" :headerText="$t('Status')" width="150" textAlign="Left" :template="ticketStatusTemplate" :customAttributes="customAttributes"></e-column>
					<e-column field="subject" :headerText="$t('Subject')" :template="TextTemplate" textAlign="Left" :customAttributes="customAttributes"></e-column>
					<e-column field="lastMessageFrom" :headerText="$t('LastMessageFrom')" textAlign="Left" :customAttributes="customAttributes"></e-column>
					<!-- <e-column :headerText="''" :template="ButtonsTemplate" :allowFiltering="false" :allowSorting="false" :customAttributes="customAttributes" width="100px"></e-column> -->
				</e-columns>
			</ejs-grid>
			<div v-if="!$store.getters.isMobile" class="messages-area" style="min-width: 35%; width: 35%; margin: 0 0 0 10px;">
				<messages-modal v-if="selectedTicket != null" :ticketId="selectedTicket.id" :isClosed="selectedTicket.status == 4"/>
			</div>
		</div>
	</div>
</template>

<script>
'use strict'

import { getSystemTickets } from "../../api/api";

import ProbablyOverflowingTextCell from '../../components/Systems/ProbablyOverflowingTextCell'
import TicketModal from "../../components/Systems/Tickets/TicketModal.vue";
import Modal from '@/components/Modal.vue';
import Vue from 'vue';

import { Sort, Page, Filter, Toolbar, Search, CommandColumn } from '@syncfusion/ej2-vue-grids';
import MessagesModal from '../../components/Settings/Tickets/MessagesModal.vue';

let context = null;

export default {
	props: {
		systemName: {
			required: false,
			type: String
		},
		systemId: {
			required: false,
			type: String
		}
	},
	provide: {
		grid: [Sort, Page, Filter, Toolbar, Search, CommandColumn],
	},
	components: {
		ProbablyOverflowingTextCell,
		Modal,
		TicketModal,
		MessagesModal
	},
	data() {
		return {
			// Creator, CreateDate, AssigneeName, SystemName, Status, Subject, Content, MessagesCount, IsRead
			tickets: [],
			mode: 'Active',
			activeModal: 'NONE',
			activeTicketId: null,
			selectedTicket: null,

			toolbar: [
				{ text: this.$t('AddTicket'), tooltipText: this.$t('AddTicket'), prefixIcon: 'e-add', id: 'add-ticket', align: 'Left' },
				{ text: this.$t('ClearFilter'), id: 'clear-filters', prefixIcon: 'e-cancel', align: 'Left', },
				'Search',
			],
			customAttributes: { class: 'customcss' },
			dateTimeFormatOptions: { format: 'yyyy-MM-dd HH:mm:ss', type: 'dateTime' },
			pageSettings: { pageSize: 100, pageSizes: [10, 25, 50, 100] },
			filterOptions: {
				type: "Menu",
			},
			selectionOptions: { 
				type: "Single" 
			},

			TextTemplate: function () {
				return {
					template: {
						extends: ProbablyOverflowingTextCell,
					},
				};
			},
			ticketStatusTemplate: function() {
				return {
					template: Vue.component("ticketStatusTemplate", {
						template: `
									<div>
										{{ status }}
									</div>
								`,
						data() {
							return {
								data: {}
							}
						},
						computed: {
							status() {
								return [this.$i18n.t('New'), 
									this.$i18n.t('Ongoing'), 
									this.$i18n.t('WaitingForApprove'), 
									this.$i18n.t('Rejected'), 
									this.$i18n.t('Closed')][this.data.status]
							}
						}
					}),
				}
			},
			ButtonsTemplate: function() {
				return {
					template: Vue.component("ticketStatusTemplate", {
						template: `
							<div v-if="data.status == 4">
								
							</div>
						`,
						data() {
							return {
								data: {}
							}
						},
						methods: {

						}
					})
				}
			}
		}
	},
	methods: {
		async getData() {
			var response = await getSystemTickets(this.systemId, this.mode);
			// console.log(response)
			this.tickets = response;
		},
		toolbarClick: function (args) {
			switch (args.item.id) {
				case 'clear-filters':
					this.$refs.grid.clearFiltering();
					break;
				case "add-ticket":
					this.activeModal = "ADD_TICKET";
					break;
			}
		},
		rowDataBound(args) {
			if (args.data["isRead"]) {
				args.row.style.backgroundColor = "#b9ede7";
			}
		},
		dataBound: function () {
			this.$refs.grid.autoFitColumns();
		},
		selectionChanged() {
            var selection = this.$refs.grid.getSelectedRecords();

            if(selection.length == 0 || selection.length > 1)
                return

			this.selectedTicket = selection[0]
        },
		closeModal() {
			this.activeModal = 'NONE';
			this.getData();
		},
	},
	async mounted() {
		context = this;

		await this.getData()
	}
}
</script>

<style>
.messages-area {
    background: rgba(243, 243, 243, 1);
    border: 1px solid rgba(224, 224, 224, 1);
    border-radius: 5px;
}
</style>


// WEBPACK FOOTER //
// src/views/System/SystemFarmerTickets.vue